<template>
  <VCard class="tw-w-full" padding="5">
    <TagIconFromTagInformations
      :tag-informations="tagInformations"
      :img-src="`smiley_${target}.svg`"
      category-type="music-type"
    >
      <template #title>
        {{ $t(`influencer.profile.slug.universe.universe_${target}`) }}
      </template>
    </TagIconFromTagInformations>
  </VCard>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

import TagIconFromTagInformations from '~/components/tag/card/iconFromTagInformations.vue'
import VCard from '~/components/ui/VCard.vue'

import type TagInformation from '~/types/tagInformations'
import type { PropType } from 'vue'

export default defineComponent({
  components: {
    TagIconFromTagInformations,
    VCard,
  },
  props: {
    tagInformations: {
      type: Array as PropType<TagInformation[]>,
      required: true,
    },
    target: {
      type: String,
      required: true,
    },
  },
})
</script>
